module.exports = __webpack_public_path__ + "static/media/4.e73c0a45.mp3";